<template>
  <bg-style :class="{ 'is-mobile': isMobile }" :radius="model.goodsRadius" :style="goodsColor"
    class="single-goods__item" @click.native="handleSubmit">
    <cover-btn v-if="editing && !goodModel.goodsId" title="设置商品" />
    <bg-style :bg="goodModel.logoBackground" :radius="[model.goodsRadius, model.goodsRadius, 0, 0]"
      class="thumb flex justify-center items-center">
      <im-image v-if="isHasCorner" :src="good.corner" class="corner-logo" />
      <img :class="goodModel.iconSizeType" :src="good.icon" alt="" class="w-full h-full relative pic">
    </bg-style>
    <div class="goods-info relative">
      <div class="name">{{ goodName }}</div>
      <div v-if="goodDescription" class="desc" v-html="goodDescription" />
      <div v-if="(hasGift || hasContents) && goodModel.giftsVisible"
        class="gifts flex items-center overflow-auto hide-scroll">
        <div v-for="(item, index) in good.item_contents" :key="`content${index}`"
          class="flex items-center mr-3 flex-shrink-0">
          <div class="prop-icon" :style="item.level_icon ? { '--level-bg': `url('${item.level_icon}')` } : null">
            <img :src="item.icon" alt="icon">
          </div>
          <span class="ml-1">
            {{ getLangIdI18n({ lang_id: item.name }, $store.state.locale.langIdData) }}</span> <i
            class="el-icon-close ml-1" /> <span>{{ item.num }}</span>
        </div>
        <div v-for="(item, index) in good.item_contents2" :key="`content${index}`"
          class="flex items-center mr-3 flex-shrink-0">
          <div class="prop-icon" :style="item.level_icon ? { '--level-bg': `url('${item.level_icon}')` } : null">
            <img :src="item.icon" alt="icon">
          </div>
          <span class="ml-1">{{ item.name }}</span> <i class="el-icon-close ml-1" /> <span>{{ item.num }}</span>
        </div>
        <div v-for="(item, index) in good.system_items" :key="'system-'+ index" class="flex items-center mr-3 flex-shrink-0">
          <div class="prop-icon">
            <img :src="item.icon" alt="icon">
          </div>
          <span class="ml-1">{{ item.name }}</span> <i class="el-icon-close ml-1" /> <span>{{ item.num }}</span>
        </div>
        <div v-for="(item, index) in good.gift_list" :key="`gift${index}`" class="flex items-center mr-3 flex-shrink-0">
          <div class="prop-icon" :style="item.level_icon ? { '--level-bg': `url('${item.level_icon}')` } : null">
            <img :src="item.gift_goods_logo" alt="icon">
          </div>
          <span class="ml-1">
            {{ getLangIdI18n({ lang_id: item.gift_goods_name }, $store.state.locale.langIdData) }}
          </span> <i class="el-icon-close ml-1" /> <span>{{ item.num }}</span>
        </div>
      </div>
      <div v-if="good.is_purchase_limit || isShowStopCountdown" class="flex items-center others justify-between">
        <div v-if="isShowStopCountdown" class="countdown">
          <span>{{ $t('siteBuild.stopCountdown') }}</span> <span class="ml-1">{{ stopCountdownDays }}d:{{
            stopCountdownHours
            }}:{{ stopCountdownMinutes }}:{{
              stopCountdownSeconds
            }}</span>
        </div>
        <div v-if="good.is_purchase_limit" class="limit">Limit {{ good.has_purchase_num }}/{{ good.limit_purchase_num }}
        </div>
      </div>
      <bg-style :bg="goodModel.buttonBackground" :radius="model.goodsRadius" class="handle-button"
        :class="{ 'sold-out': isSaleOut }" @click.native.stop="handleBuy">
        <div v-if="isShowCountdown" class="relative price">
          <span class="day">{{ countdownDays }} <em class="not-italic">Day</em></span> <span>{{ countdownHours }}:{{
            countdownMinutes
            }}:{{ countdownSeconds }}</span>
        </div>
        <span v-else-if="isSaleOut" class="price relative">SOLD OUT</span>
        <template v-else>
          <span class="price relative">{{ priceInfo.priceTxt }}</span> <span v-if="hasOriginalPrice"
            class="origin-price relative">{{ originalPriceInfo.priceTxt }}</span>
        </template>
      </bg-style>
    </div>
  </bg-style>
</template>

<script>
import { cloneDeep } from 'lodash-es'
import { colord } from 'colord'
import goodMixins from '~/site/widgets/storeWidget/oneGood/goodMixins'
import { getTextColor } from '~/utils'
import CoverBtn from '~/components/common/CoverBtn.vue'

export default {
  name: 'GoodsItem',
  components: { CoverBtn },
  mixins: [goodMixins],
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    good: {
      type: Object,
      default() {
        return {}
      }
    },
    editing: {
      type: Boolean,
      default: false
    },
    goodModel: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    goodsColor() {
      return {
        '--button-color': getTextColor(this.goodModel.priceBackground).color,
        '--goods-title-color': getTextColor(this.goodModel.nameBackground).color,
        '--secondary-color': getTextColor(this.goodModel.secondaryTextColor).color,
        '--goods-border-radius': this.model.goodsRadius + 'px',
        '--goods-background-color': getTextColor(this.goodModel.background).color,
        '--goods-price-color-30': colord(this.goodModel.priceBackground.backgroundColor).alpha(0.3).toRgbString()
      }
    }
  },
  methods: {
    handleSubmit() {
      if (this.isSaleOut) return
      this.$emit('item-click', cloneDeep(this.good), cloneDeep(this.goodModel))
    },
    handleBuy() {
      if (this.isShowCountdown || this.isSaleOut) return
      this.$emit('buy', cloneDeep(this.good))
    }
  }
}
</script>

<style lang="less">
.single-goods__item {
  width: 100%;
  transition: all .2s ease-in-out;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(109, 93, 67, .24);
  background: var(--goods-background-color);

  &:hover {
    transform: translateY(-4px) translateZ(0);

    .cover-wrap__btn {
      opacity: 1;
    }
  }

  .cover-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 100;
  }

  .thumb {
    height: 255px;

    .corner-logo {
      width: 97px;
      height: 97px;
      position: absolute;
      left: -4px;
      top: -5px;
      z-index: 10;
    }

    .pic {
      border-radius: var(--goods-border-radius) var(--goods-border-radius) 0 0;
    }
  }

  .goods-info {
    padding: 20px;
    border-radius: 0 0 var(--goods-border-radius) var(--goods-border-radius);

    .name {
      font-weight: 500;
      font-size: 16px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      color: var(--goods-title-color);
    }

    .desc {
      font-size: 15px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      margin-top: 10px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      color: var(--secondary-color);
    }

    .gifts {
      margin-top: 10px;
      font-size: 14px;
      color: var(--secondary-color);

      .prop-icon {
        position: relative;
        width: 30px;
        height: 30px;
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        &.has-level {
          background: var(--level-bg) no-repeat;
          background-size: 100% 100%;

          img {
            width: 80%;
            height: 80%;
          }
        }
      }
    }

    .others {
      margin-top: 10px;
      font-size: 14px;
      color: var(--secondary-color);

      .limit {
        border: 1px solid var(--secondary-color);
        border-radius: 4px;
        padding: 0 5px;
      }
    }

    .handle-button {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 16px;
      color: var(--button-color);

      &.sold-out {
        opacity: 0.6;
        cursor: not-allowed;
        pointer-events: none;
      }

      .origin-price {
        text-decoration: line-through;
        font-size: 12px;
        margin-left: 8px;
      }
    }
  }

  &.is-mobile {
    width: 100%;

    &:hover {
      transform: none;
    }

    .thumb {
      height: 150px;
    }

    .goods-info {
      height: auto;
      padding: 16px;

      .name {
        font-size: 16px;
      }

      .desc {
        font-size: 12px;
      }

      .gifts {
        font-size: 12px;

        .prop-icon {
          width: 20px;
          height: 20px;
        }
      }

      .others {
        font-size: 12px;
      }

      .handle-button {
        margin-top: 10px;
      }
    }
  }
}
</style>
